import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {ScannerSide, ScannerChartingStudy} from '../../interfaces/scanner.enums';
import {IBBandsScanRule, chartingSaved} from '../../interfaces/scanner.interfaces';
import {HistoryItemPeriod} from '../../../../interfaces/historyItem';



@Component({
    selector: 'app-scanner-BollingerBands',
    template: require('./scanner-BollingerBands.component.html'),
    styles: [require('./scanner-BollingerBands.component.scss')]
})
export class ScannerBollingerBandsSelectorComponent extends AppComponentBase implements OnInit,
    AfterViewInit,
    OnDestroy {

    ngAfterViewInit(): void {
        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            //this.workspace.initLoadScan = null;
        }
    }

    public loadScanData(v: any) {



        let loadScanData: chartingSaved = (!this.narrowScannerMode) ? <chartingSaved> v.savedData : <chartingSaved> v.savedDataSecondary;

        //console.log(v);
        this.workspace.scannerSearch_period = loadScanData.period;

        let scanRule: IBBandsScanRule = <IBBandsScanRule> loadScanData.rule;
        this.period = scanRule.period;
        this.workspace.scannerSearch_side = scanRule.direction;
        this.deviation = scanRule.deviation;
        this.enableAdvancedSetup = true;

        if(scanRule.direction == ScannerSide.SCANNER_SIDE_BUY) {
            this.oversold = true;

        }
        if(scanRule.direction == ScannerSide.SCANNER_SIDE_SELL) {
            this.overbought = true;

        }
        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }



    constructor(injector: Injector) {
        super(injector);

        if(!this.workspace.isNarrowScanMode) {
            this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }


        this.workspace.globaGridMode.changeScannerSide.subscribe(v => {
            if(!this.narrowScannerMode) {
                if(this.workspace.scannerSearch_chartingstudy == ScannerChartingStudy.SCANNER_BOLLINGERBANDS) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })

        this.workspace.globaGridMode.changeScannerNarrowSide.subscribe(v => {
            if(this.narrowScannerMode) {
                if(this.workspace.scannerSearch_Narrow_chartingstudy == ScannerChartingStudy.SCANNER_BOLLINGERBANDS) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })

        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            if(v.study == ScannerChartingStudy.SCANNER_BOLLINGERBANDS)
                this.loadScanData(v)

        });





    }
    public subscribers: any = {};
    public loaderSubscribed: boolean = false;
    ngOnDestroy() {
        //  this.subscribers.load.unsubscribe();
    }
    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value
        if(value == true) {

            this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));

        }
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }


    //value: number = 5;

    private _period: number = 20;
    public get period(): number {
        return this._period;
    }
    public set period(value: number) {
        this._period = value < 1 ? 1 : value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isPeriodValid() {
        return !isNaN(Number(this.period))
    }


    private _deviation: number = 2;
    public get deviation(): number {
        return this._deviation;
    }
    public set deviation(value: number) {
        this._deviation = value < 1 ? 1 : value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.period, deviation: this.deviation};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get isDeviationValid() {
        return !isNaN(Number(this.deviation))
    }

    public get isBandSelectedValid() {
        return this.overbought || this.oversold;
    }


    private _enableAdvancedSetup: boolean = false;
    public get enableAdvancedSetup(): boolean {
        return this._enableAdvancedSetup;
    }
    public set enableAdvancedSetup(value: boolean) {
        this._enableAdvancedSetup = value;
    }


    private _overbought: boolean = false;
    public get overbought(): boolean {
        return this._overbought;
    }
    public set overbought(value: boolean) {
        this._oversold = !value;
        this._overbought = value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.period, deviation: this.deviation};
            }

            this.oversold = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }


    private _oversold: boolean = true;
    public get oversold(): boolean {
        return this._oversold;
    }
    public set oversold(value: boolean) {
        this._oversold = value;
        this._overbought = !value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }

                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.period, deviation: this.deviation};
            }

            this.overbought = false;
        }
        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }

    }


    public overboughtAction() {
        this.overbought = !this.overbought
    }

    public oversoldAction() {
        this.oversold = !this.oversold
    }






    ngOnInit() {
    }
    public scanRule: IBBandsScanRule = {direction: this.workspace.scannerSearch_side, period: this.period, deviation: this.deviation};


}

